import { useCallback, useState } from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { Field } from 'react-final-form';

import { IKnmErknmFormViolatedRequirementsNpa } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormViolatedRequirementsNpa';
import { KnmViolatedRequirementsNpaItem } from 'KnmPackage/KnmViolatedRequirementsNpa/components/KnmViolatedRequirementsNpaItem';
import { ErknmResultDecisionsViolatedRequirementsModal } from 'KnmErknmPackage/ErknmResultDecisionsModule/components/ErknmResultDecisionsViolatedRequirementsModal';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { getRequirementsWithNonFixedViolations } from 'KnmErknmPackage/ErknmViolationsModule/common/getRequirementsWithNonFixedViolations';

import { Button } from '../../../UIPackage/MainModule/components/Button';
import { FieldBlock } from '../../../UIPackage/FormModule/components/FieldBlock';

interface IDecisionEliminatedViolationsProps {
  watchOnly: boolean;
  formRef: IDecisionFormRef | undefined;
  requirementsNpa: IKnmErknmFormViolatedRequirementsNpa[] | undefined;
  requirementEliminationsFieldName: string;
}

export const DecisionEliminatedViolations = ({
  watchOnly,
  formRef,
  requirementsNpa,
  requirementEliminationsFieldName,
}: IDecisionEliminatedViolationsProps) => {
  const push = formRef?.current.mutators.push;
  const remove = formRef?.current.mutators.remove;

  const requirementsWithUnresolvedViolations = getRequirementsWithNonFixedViolations(requirementsNpa || []);

  const removeViolatedRequirementsNpa = useCallback((npaIndex: number) => {
    remove && remove(requirementEliminationsFieldName, npaIndex);
  }, []);

  const [isViolatedRequirementsNpaModalVisible, setIsViolatedRequirementsNpaModalVisible] = useState(false);
  const openViolatedRequirementsNpaModal = useCallback(() => {
    setIsViolatedRequirementsNpaModalVisible(true);
  }, []);
  const closeViolatedRequirementsNpaModal = useCallback(() => {
    setIsViolatedRequirementsNpaModalVisible(false);
  }, []);
  const addViolatedRequirementsNpa = (items: IKnmErknmFormViolatedRequirementsNpa[]) => {
    push &&
      items.forEach(item => {
        push(requirementEliminationsFieldName, item);
      });
  };

  return (
    <>
      <FieldBlock
        label="Устраняемые нарушения обязательных требований"
        button={
          <Button
            className="shared-btn-add"
            text="Добавить"
            type="button"
            variant="link"
            color="primary"
            disabled={watchOnly}
            onClick={openViolatedRequirementsNpaModal}
          />
        }
      >
        <FieldArray name={requirementEliminationsFieldName}>
          {({ fields, meta: listMeta }) => {
            return (
              <>
                {fields.map((npaName, npaIndex) => {
                  const fieldValue: IKnmErknmFormViolatedRequirementsNpa = fields.value?.[npaIndex];

                  const correspondingActRequirement = formRef?.current
                    .getState()
                    .values.violatedMandatoryRequirements?.find(
                      requirement => requirement.npa.id === fieldValue.npa.id,
                    );

                  return (
                    <Field key={npaName} name={npaName}>
                      {({ meta: itemMeta }) => {
                        const isFieldTouched = itemMeta.touched;
                        const errorField = itemMeta.error;

                        return (
                          <KnmViolatedRequirementsNpaItem
                            value={fieldValue}
                            name={npaName}
                            watchOnly={watchOnly}
                            isViolationFieldsWatchOnly={watchOnly}
                            onRemove={() => removeViolatedRequirementsNpa(npaIndex)}
                            addMandatory={() => undefined}
                            touched={isFieldTouched}
                            error={errorField}
                            formRef={formRef}
                            isMandatoryDisabled={true}
                            isInsideDecisionsSection
                            actRequirement={correspondingActRequirement}
                            isDecision
                          />
                        );
                      }}
                    </Field>
                  );
                })}
                {typeof listMeta.error === 'string' && listMeta.touched && (
                  <p className="shared-input-error shared-row__small-margin">{listMeta.error}</p>
                )}
              </>
            );
          }}
        </FieldArray>
      </FieldBlock>
      <ErknmResultDecisionsViolatedRequirementsModal
        requirementsNpa={requirementsWithUnresolvedViolations}
        visible={isViolatedRequirementsNpaModalVisible}
        onClose={closeViolatedRequirementsNpaModal}
        onSubmit={addViolatedRequirementsNpa}
      />
    </>
  );
};
